import * as Sentry from '@sentry/react'

export default function mapServerErrors(error, setError, showMessage, getValues) {
    const data = error.response?.data

    if (!data) {
        Sentry.captureException(error, {
            extra: 'extra',
        })
        showMessage({ text: 'حدث خطأ أثناء الطلب.' })
        return
    }

    if (data.non_field_errors) {
        showMessage({ text: data.non_field_errors.join('\n') })
        return
    } else if (data.detail) {
        showMessage({ text: data.detail })
        return
    }

    const fieldExists = (path) => {
        try {
            const values = getValues?.()
            if (!values) return true

            return path.split('.').reduce((acc, key) => {
                if (acc === undefined || acc === null) return undefined
                return acc[key]
            }, values) !== undefined
        } catch {
            return true
        }
    }

    let fallbackMessages = []

    const walk = (obj, path = '') => {
        if (Array.isArray(obj)) {
            obj.forEach((item, index) => {
                const newPath = path ? `${path}.${index}` : index.toString()

                if (typeof item === 'string') {
                    if (fieldExists(path)) {
                        setError(path, { type: 'server', message: item })
                    } else {
                        fallbackMessages.push(item)
                    }
                } else {
                    walk(item, newPath)
                }
            })
        } else if (typeof obj === 'object' && obj !== null) {
            Object.entries(obj).forEach(([key, value]) => {
                const newPath = path ? `${path}.${key}` : key

                if (Array.isArray(value) && value.every(v => typeof v === 'string')) {
                    if (fieldExists(newPath)) {
                        setError(newPath, {
                            type: 'server',
                            message: value.join(' ')
                        })
                    } else {
                        fallbackMessages.push(value.join(' '))
                    }
                } else {
                    walk(value, newPath)
                }
            })
        }
    }

    walk(data)

    if (fallbackMessages.length) {
        showMessage({ text: fallbackMessages.join('\n') })
    }
}